module.exports = __webpack_public_path__ + "img/reticule3.8ad12cdb.jpg";